import React from 'react';
import Styled from './styled';

interface Props {
  isFullscreen: boolean;
  children: any;
}

const MobileHide = ({ isFullscreen, children }: Props) => (
  <Styled.Container isHidden={window.Widget.isMobile && !isFullscreen}>{children}</Styled.Container>
);

export default MobileHide;
